(function () {
  'use strict';

  // ── Whitelist: dt values to show (partial match, case-insensitive) ──
  var WHITELIST = [
    'Icon 1',
    'Icon 2',
    'Icon 3',
    'Text Top',
    'Text Bottom',
    'Text Color Bottom',
    'Text Color Top',
    'Font Style'
  ];

  // Lowercase once for fast comparisons
  var whitelist = WHITELIST.map(function (w) { return w.toLowerCase(); });

  function filterProperties(root) {
    var properties = (root || document).querySelectorAll('.cart-items__property');
    properties.forEach(function (prop) {
      var dt = prop.querySelector('dt');
      if (!dt) return;

      var dtText = (dt.textContent || '').trim().replace(/:$/, '').toLowerCase();

      var shouldShow = whitelist.some(function (keyword) {
        return dtText.indexOf(keyword) !== -1;
      });

      if (shouldShow) {
        prop.setAttribute('data-rh-show', '');
      } else {
        prop.removeAttribute('data-rh-show');
      }
    });
  }

  // ── Run on any DOM mutation (catches hydration, innerHTML swaps, AJAX) ──
  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      filterProperties(document);
    }, 50);
  });

  // Start observing once DOM is ready
  function start() {
    filterProperties(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
